/**
 * Base call voor het ophalen van alle data.
 */

import {
	fetchDataError,
	fetchDataPending,
	fetchPaginationSuccess,
	fetchTeasersSuccess,
	filterByCategory,
	filterByTool,
	filterByValue,
	filterByPage,
	fetchFacetsSuccess,
	setQueryValue,
	orderBy
} from '../reducers';

export default function fetchData ( page, query, categories, tools, order ) {

	const reactAppData = window.wpApiSettings || {};
	const { nonce } = reactAppData

	return dispatch => {

		/**
		 * Zet actieve filters
		 */


		if ( query && '' !== query ) {
			dispatch( filterByValue( query ) );
			dispatch( setQueryValue( query ) );
		} else {
			dispatch( filterByValue( '' ) );
		}

		if ( page && '' !== page ) {
			dispatch( filterByPage( page ) );
		}

		if ( categories && '' !== categories ) {
			dispatch( filterByCategory( categories ) )
		} else {
			dispatch( filterByCategory( '' ) )
		}

		if ( tools && '' !== tools ) {
			dispatch( filterByTool( tools ) )
		} else {
			dispatch( filterByTool( '' ) )
		}

		if ( order && '' !== order ) {
			dispatch( orderBy( order ) )
		} else {
			dispatch( orderBy( '' ) )
		}

		/**
		 * Wachtstatus
		 */

		dispatch( fetchDataPending() );

		/**
		 * Haal data op
		 */

		 let pageQuery = 'undefined' !== typeof page && page !== '' ? 'page=' + page : '';
		 let categoryQuery = 'undefined' !== typeof categories && categories !== '' && categories.length > 0 ? '&categories=' + categories : '';
		 let searchQyery = 'undefined' !== typeof query && query !== '' && query.length > 0 ? '&q=' + query : '';
		 let toolQuery = 'undefined' !== typeof tools && tools !== '' && tools.length > 0 ? '&tech=' + tools : '';
		 let orderQuery = 'undefined' !== typeof order && order !== '' ? '&order=' + order : '';

		let searchUrl = '/wp-json/typografics/v1/knowledge' + (page !== '' || query !== '' || categories !== '' || tools !== '' || order !== '' ? '?' : '') + pageQuery + searchQyery + categoryQuery + toolQuery + orderQuery

		fetch( searchUrl, { 
			credentials: 'include',
			headers: {
				'content-type': 'application/json',
				'X-WP-Nonce': nonce
			}
		} )
			.then( result => result.json() )
			.then( result => {

				if ( result.error ) {
					throw ( result.error );
				}

				dispatch( fetchPaginationSuccess( result.count, result.page, result.pages ) );
				dispatch( fetchFacetsSuccess( result.categories, result.tools ) );
				dispatch( fetchTeasersSuccess( result.results ) );

				return result.results;
			} )
			.catch( error => {
				dispatch( fetchDataError( error ) );
			} )
	}
}


